import { SprinklesElement } from "sprinkles-js";

export default class ToastElement extends SprinklesElement {
  static tagName = "toast-element";
  static refs = ["dismiss"];
  static events = { click: { method: "dismiss", ref: "dismiss" } };

  #timeout = null;

  afterConnected() {
    this.#timeout = setTimeout(() => this.remove(), 5000);
  }

  beforeDisconnect() {
    this.#clearTimeout();
  }

  dismiss() {
    this.#clearTimeout();
    this.remove();
  }

  #clearTimeout() {
    if (this.#timeout) {
      clearTimeout(this.#timeout);
      this.#timeout = null;
    }
  }
}
